/* eslint eqeqeq: "off" */
import { Step, StepLabel, Stepper } from "@material-ui/core";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../../_metronic/layout";
import { ProcessingStep } from "./components/steps/ProcessingStep";
import { ResultsStep } from "./components/steps/ResultsStep";
import { ReviewStep } from "./components/steps/ReviewStep";
import { UploadStep } from "./components/steps/UploadStep";
import { ValidationStep } from "./components/steps/ValidationStep";
import { STEPS } from "./constants/steps";
import { BulkUploadProvider } from "./context/BulkUploadContext";
import { useBulkUpload } from "./hooks/useBulkUpload";
import { getProgramCourseFee } from "./utils/programFee";

// Wrapper component to use context
function BulkUploadContent({ programDetails, programId }) {
  const { state } = useBulkUpload();
  const { program } = programDetails;
  const { course, fee, problem: feeProblem } = getProgramCourseFee(
    programDetails
  );

  const renderStepContent = () => {
    switch (state.activeStep) {
      case 0:
        return <UploadStep programId={programId} />;
      case 1:
        return (
          <ValidationStep
            programStartDate={program.startdate}
            programId={programId}
          />
        );
      case 2:
        return <ReviewStep programDetails={programDetails} />;
      case 3:
        return (
          <ProcessingStep
            programId={programId}
            programDetails={programDetails}
          />
        );
      case 4:
        return <ResultsStep />;
      default:
        return null;
    }
  };

  return (
    <Fragment>
      <Card>
        <CardHeader
          title={`${course?.course_name} | ${course?.course_code} | ${program.school_name}`}
        >
          <CardHeaderToolbar>{/* Optional actions */}</CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="row text-center mb-4">
            <div className="col-md-3">
              <div className="font-weight-bold text-muted mb-2">Course Fee</div>
              <div className="font-size-h5">
                {fee?.course_fee != null
                  ? `$${Number(fee.course_fee).toFixed(2)}`
                  : "Not set"}
              </div>
              {fee?.course_fee != null && (
                <div className="text-muted font-size-sm">
                  {fee.source === "override"
                    ? "Program custom fee"
                    : "Branch default"}
                </div>
              )}
            </div>
            <div className="col-md-3">
              <div className="font-weight-bold text-muted mb-2">Day</div>
              <div className="font-size-h5">{program.day}</div>
            </div>
            <div className="col-md-3">
              <div className="font-weight-bold text-muted mb-2">Dates</div>
              <div className="font-size-h5">
                {new Date(program.startdate).toLocaleDateString()} <br />
                <span className="text-muted">to</span> <br />
                {new Date(program.enddate).toLocaleDateString()}
              </div>
            </div>
            <div className="col-md-3">
              <div className="font-weight-bold text-muted mb-2">Sessions</div>
              <div className="font-size-h5">{program.sessions}</div>
            </div>
          </div>
          {feeProblem && (
            <div className="alert alert-custom alert-light-danger mb-0">
              <div className="alert-text">{feeProblem}</div>
            </div>
          )}
        </CardBody>
      </Card>

      <Card className="mt-5">
        <CardBody>
          <Stepper activeStep={state.activeStep} alternativeLabel>
            {STEPS.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <div className="mt-8">{renderStepContent()}</div>
        </CardBody>
      </Card>
    </Fragment>
  );
}

export function ProgramBulkUpload() {
  const suhbeader = useSubheader();
  const { id } = useParams();
  const location = useLocation();
  const [validAccess, setValidAccess] = useState(true);
  const [programDetails, setProgramDetails] = useState(null);

  useEffect(() => {
    suhbeader.setTitle("Bulk Upload Students");

    const programIdFromState = location.state?.programId;
    if (!programIdFromState || programIdFromState != id) {
      console.warn("Possible URL tampering detected");
      setValidAccess(false);
      return;
    }
    const fetchProgramData = async () => {
      try {
        const res = await axios.get(
          `/api/school-programs-bulk-upload/program-details/${id}`
        );
        setProgramDetails(res.data);
      } catch (error) {
        console.error("Error fetching program data:", error);
      }
    };

    fetchProgramData();
  }, [id, location, suhbeader]);

  if (!validAccess) {
    return (
      <Card>
        <CardBody>
          <div className="text-danger">
            Unauthorized access. Please return to the program list.
          </div>
        </CardBody>
      </Card>
    );
  }

  if (!programDetails) {
    return (
      <Card>
        <CardBody>Loading program details...</CardBody>
      </Card>
    );
  }

  return (
    <BulkUploadProvider>
      <BulkUploadContent programDetails={programDetails} programId={id} />
    </BulkUploadProvider>
  );
}
